// extracted by mini-css-extract-plugin
export default {"mailing":"_-_-_-plugins-jacow-indico_jacow-client-___mailing_lists-module__mailing___9POcn"};